import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';
import jwt_decode from 'jwt-decode';
import { AuthToken, LoginDTO, UserDTO, UsuarioNewPass } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

const TOKEN_KEY = 'auth-token';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

  baseURL = `${environment.apiUrl}/usuario`;
  constructor(private http: HttpClient, private router: Router) { }

  /**
   * Returns the current user
   */
  public currentUser(): AuthToken | null {
    return this.getDecodedAccessToken();
  }

  /**
   * Performs the auth
   * @param LoginDTO user
   */
  login(user: LoginDTO): Observable<{ user: UserDTO, access_token: string }> {
    return this.http.post<{ user: UserDTO, access_token: string }>(`${this.baseURL}/auth`, user)
  }

  /**
   * Reset password
   * @param email email
   */
  resetPassword(user: LoginDTO): Observable<{ user: UserDTO, access_token: string }> {
    return this.http.post<{ user: UserDTO, access_token: string }>(`${this.baseURL}/recovery`, user)
  }

  /**
* Update Password
* @param email email
*/
  updatePassword(user: UsuarioNewPass): Observable<{ user: UserDTO }> {
    return this.http.put<{ user: UserDTO }>(`${this.baseURL}/updatepass`, user)
  }

  /**
   * Logout the user
   */
  logout() {
    window.sessionStorage.clear();
    this.router.navigate(['/account/login']);
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(token: string): string | null {
    return window.sessionStorage.getItem(token);
  }

  public decodeResetToken(token: string): { id: string, unique_name: string } | null {
    try {
      return jwt_decode(token!);
    } catch (Error) {
      return null;
    }
  }


  getDecodedAccessToken(): AuthToken | null {
    const token = this.getToken(TOKEN_KEY);
    try {
      return jwt_decode(token!);
    } catch (Error) {
      return null;
    }
  }
}

